import { render, staticRenderFns } from "./DAddressPreview.vue?vue&type=template&id=097b1557&"
import script from "./DAddressPreview.vue?vue&type=script&lang=js&"
export * from "./DAddressPreview.vue?vue&type=script&lang=js&"
import style0 from "./DAddressPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports